<div style="margin-top: 10px;">
  <form [formGroup]="linerServiceListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row" style="margin-top: 20px;">
          @if (addPermission) {
            <a class="__add_client" (click)="openLinerForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Liner Service
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <table mat-table matSort [dataSource]="linerDataSource" (matSortChange)="sortData($event)">
              <ng-container matColumnDef="lineName">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Line</span>
                    <input placeholder="Line..." type="search" matInput
                      autocomplete="off" formControlName="lineName" class="mat-input-custom">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.lineName}}</td>
                </ng-container>
                <ng-container matColumnDef="consortiumName">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Consortium</span>
                      <input placeholder="Consortium..." type="search" matInput
                        autocomplete="off" formControlName="consortiumName" class="mat-input-custom">
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.consortiumName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="polName" style="width: 200px;">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>POL</span>
                        <input placeholder="POL..." type="search" matInput
                          autocomplete="off" formControlName="polName" class="mat-input-custom">
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element">{{element.polName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="destinationName">
                      <th mat-header-cell *matHeaderCellDef class="header">
                        <div class="sorting_header">
                          <span mat-sort-header>FDC</span>
                          <input placeholder="FDC..." type="search" matInput
                            autocomplete="off" formControlName="destinationName" class="mat-input-custom">
                          </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.destinationName}}</td>
                      </ng-container>
                      <ng-container matColumnDef="viaDestinationNames">
                        <th mat-header-cell *matHeaderCellDef class="header">
                          <div class="sorting_header">
                            <span mat-sort-header>POD(s)</span>
                            <input placeholder="POD..." type="search" matInput
                              autocomplete="off" formControlName="viaDestinationName" class="mat-input-custom">
                            </div>
                          </th>
                          <td mat-cell style="width: 100px;" *matCellDef="let element">{{element.viaDestinationNames}}</td>
                        </ng-container>
                        <ng-container matColumnDef="modeNames">
                          <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                              <span mat-sort-header>Mode</span>
                            </div>
                          </th>
                          <td mat-cell style="width: 100px;" *matCellDef="let element">{{element.modeNames}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                              <span mat-sort-header>Status</span>
                              <mat-select formControlName="status" placeholder="Search by Status">
                                @for (status of statusTypes; track status) {
                                  <mat-option [value]="status.key">
                                    {{status.label}}
                                  </mat-option>
                                }
                              </mat-select>
                            </div>
                          </th>
                          <td mat-cell *matCellDef="let element">{{element.status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef>
                            <span class="mat-sort-header-content" >Action</span></th>
                            <td class="__action_row" mat-cell *matCellDef="let element">
                              <span class="__action_edit_icon" (click)="openLinerForm(element.id)">
                                <mat-icon>create</mat-icon>
                              </span>
                              @if (element.globallyDeactivated && reactivatePermission) {
                                <span style="margin-left: 2px;">
                                  <mat-checkbox (change)="deactivateChanged(element.id,$event)"></mat-checkbox>
                                </span>
                              }
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="linerServiceColumns; sticky: true"></tr>
                          <tr mat-row *matRowDef="let row; columns: linerServiceColumns;"></tr>
                        </table>
                      </div>
                    }
                  </mat-card-content>
                  <mat-card-actions>
                  </mat-card-actions>
                </mat-card>
                <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalRecords" showFirstLastButtons></mat-paginator>
              </form>
            </div>
